import { ShoppingCart } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { Badge } from "./ui/badge";

export default function Navbar() {
  const { itemCount, openCart } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  const goToSection = (id) => {
    if (onHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
      // give the route transition a tick to mount the section
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 80);
    }
  };

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-40 glass-surface border-b border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/brand/logotype.png"
            alt="Sanctum Sonics"
            className="h-5 md:h-6 w-auto"
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/catalog"
            data-testid="nav-beats"
            className="text-sm tracking-widest uppercase metal-gold-text hover:brightness-125 transition"
          >
            Catalog
          </Link>
          <button
            data-testid="nav-forge"
            onClick={() => goToSection("forge")}
            className="text-sm tracking-widest uppercase metal-gold-text hover:brightness-125 transition"
          >
            The Forge
          </button>
        </div>

        <button
          data-testid="cart-button"
          onClick={openCart}
          className="relative p-2 metal-gold-icon hover:brightness-125 transition"
        >
          <ShoppingCart size={20} />
          {itemCount > 0 && (
            <Badge
              className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-[10px] metal-gold-surface border-0 rounded-full"
            >
              {itemCount}
            </Badge>
          )}
        </button>
      </div>
    </nav>
  );
}
